// extracted by mini-css-extract-plugin
module.exports = {"chipContainer":"Chip_chipContainer__vD8L_","chip":"Chip_chip__IHg3y","chipDelete":"Chip_chipDelete__ygCah"};